import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import WhatActuallyDrivesPipeline from '../components/WhatActuallydrivesPipeline'

export default function B2BIntentDataVsTraditionalLeadScoring() {
  return (
    <div>
      <Header1/>
      <WhatActuallyDrivesPipeline/>
      <Footer/>
    </div>
  )
}
